import { render } from "./Results.vue?vue&type=template&id=67be0d28&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=67be0d28&scoped=true&lang=css"
import "./Results.vue?vue&type=style&index=1&id=67be0d28&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67be0d28"]])

export default __exports__